var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("pages-wrapper", [
    _c(
      "div",
      { staticClass: "gift-card" },
      [
        _c("h1", { staticClass: "gift-title" }, [
          _vm._v("\n      " + _vm._s(_vm.pageTitle) + "\n    ")
        ]),
        _c("fragment", {
          attrs: { prefetch: "", "slot-name": "gift_card_page_head" }
        }),
        _c("banners-slot", {
          attrs: { "with-category": false, "slot-name": "banner_info_gift" }
        }),
        _c("fragment", {
          attrs: { prefetch: "", "slot-name": "gift_card_page_footer" }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }